document.addEventListener('click', function (e) {
  // Ignore clicks that happen inside Shopify's gallery viewer modal
  if (e.target.closest('.gallery-viewer-modal')) return;

  // Detect any Shop The Look trigger button
  const btn = e.target.closest(
    '[data-open-stl], [data-stl-open], [data-stl-trigger], [data-open-shop-the-look], .pm-stl-overlay-btn'
  );
  if (!btn) return;

  // Try to trigger the app’s existing open button if present
  const trigger = document.querySelector(
    '.js-shopthelook-trigger, .shopthelook-button, .shop-the-look-btn, [data-open-shop-the-look]'
  );

  if (trigger) {
    trigger.click(); // delegates to the native app’s button
  } else if (window.BSS_ShopTheLook && typeof window.BSS_ShopTheLook.open === 'function') {
    // fallback if your app exposes a JS API
    try {
      window.BSS_ShopTheLook.open();
    } catch (err) {
      console.warn('BSS ShopTheLook trigger error:', err);
    }
  } else {
    // last fallback – manually show your custom modal if exists
    const popup = document.querySelector('#shopTheLook, .shop-the-look-container');
    if (popup) popup.style.display = 'block';
  }
});